import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';
import './legal.css';

/**
 * Shared shell for the privacy / terms / data-deletion pages. All three need
 * stable public URLs that Google Play can reach without auth (for app review),
 * so they live outside the Protected tree and render with their own minimal
 * header + footer.
 */
const LegalPage = ({ title, updated, children }) => (
  <div className="legal-page">
    <header className="legal-header">
      <Link to="/login" className="legal-brand" aria-label="EduManage home">
        <Logo size={28} showWordmark wordmarkSize={15} />
      </Link>
      <nav className="legal-nav">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/data-deletion">Data deletion</Link>
      </nav>
    </header>

    <main className="legal-main">
      <h1 className="legal-title">{title}</h1>
      {updated && <p className="legal-updated">Last updated: {updated}</p>}
      <div className="legal-body">{children}</div>
    </main>

    <footer className="legal-footer">
      <div>© {new Date().getFullYear()} RT Connect Technology Pvt Ltd — India</div>
      <div className="legal-foot-links">
        <Link to="/privacy">Privacy</Link>
        <span>·</span>
        <Link to="/terms">Terms</Link>
        <span>·</span>
        <Link to="/data-deletion">Data deletion</Link>
        <span>·</span>
        <a href="mailto:pramod@rtconnect.in">Contact</a>
      </div>
    </footer>
  </div>
);

export default LegalPage;
